import { render, staticRenderFns } from "./AddWidgetDialog.vue?vue&type=template&id=2f1d9154&scoped=true&"
import script from "./AddWidgetDialog.vue?vue&type=script&lang=js&"
export * from "./AddWidgetDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddWidgetDialog.vue?vue&type=style&index=0&id=2f1d9154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d9154",
  null
  
)

export default component.exports